import $ from 'jquery';
import { hideLoading, showLoading } from './utils';

var PriceSearch = {
  form    : null,
  results : null,
  request : null,

  init: function() {
    this.form = $('#price-form');
    this.results = $('#search-results');
    this.makers = this.form.find('#maker-select');
    this.models = this.form.find('#model-select');

    if(this.form.length !== 0) {
      this.loadMakers();
      this.loadModels();

      this.bindEvents();
    }
  },

  bindEvents: function() {
    this.makers.on('change', this.loadModels);
    this.form.on('submit', this.submitSearch);
  },

  submitSearch: function(e) {
    e.preventDefault();

    if(PriceSearch.request !== null) {
      PriceSearch.request.abort();
    }

    showLoading();
    PriceSearch.request = $.post('/price-history/results', PriceSearch.form.serialize(), function(data) {
      PriceSearch.results.html(data);
      hideLoading();
      $('.after-search').show();

      Sorter.init();
    });
  },

  loadMakers: function() {
    if (PriceSearch.makers.length < 1) return;

    PriceSearch.makers.html("<option value=''>Loading Makers</option>");
    $.getJSON('/start/makers.json', PriceSearch.form.serialize(), function(data) {
      var options = "<option value=''>Select Maker</option>";

      data.forEach(function(item, i, array) {
        options += "<option value='" + item.maker + "'>" + item.maker + "</option>\n";
      });

      PriceSearch.makers.html(options);
    });
  },

  loadModels: function() {
    if (PriceSearch.makers.length < 1) return;

    showLoading();
    PriceSearch.models.html("<option value=''>Loading Models</option>");
    if( PriceSearch.makers.val() !== '' ) {
      $.getJSON('/start/models.json', PriceSearch.form.serialize(), function(data) {
        var options = "<option value=''>Select Model</option>";

        data.forEach(function(item, i, array) {
          options += "<option value='" + item.model + "'>" + item.model + "</option>\n";
        });

        PriceSearch.models.html(options);
        hideLoading();
      });
    } else {
      PriceSearch.models.html("<option value=''>Model - select maker first</option>");
      hideLoading();
    }
  }
};

export default PriceSearch;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/price_search.js